export function createFilterContext({ salesperson, year, region = "all", displayCurrency = "AED" }) {
    return { salesperson, year, region, displayCurrency };
}
